import { useMember } from '../context/MemberContext';
import './Page.css';
import './QrPage.css';

export default function QrPage() {
  const { member } = useMember();

  return (
    <div className="page">
      <header className="page-header">
        <h1 className="page-header__title">Access</h1>
      </header>
      <div className="page-content qr-content">
        {member?.qrCodeUrl ? (
          <div className="qr-card">
            <p className="qr-label">{member.firstName} {member.lastName}</p>
            <img
              src={member.qrCodeUrl}
              alt="Member QR Code"
              className="qr-image"
            />
            <p className="qr-hint">Present this code at the scanner</p>
          </div>
        ) : (
          <p className="qr-empty">No QR code available for your account.</p>
        )}
      </div>
    </div>
  );
}
